import React from "react";
import { LegacyCard, Stack } from "@shopify/polaris";
import { Field } from "react-final-form";
import SelectionLogicField from "./components/SelectionLogicField.js";
import SelectedTagsField from "../../../../../../../../../common/SelectedTagsField/SelectedTagsField.js";

const TagsSelectionCard = () => {
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <div style={{ maxWidth: "350px" }}>
          <Stack distribution={"fill"}>
            <Field name={"tagsSelectionLogic"} component={SelectionLogicField} />
            <Field name={"selectedTags"} component={SelectedTagsField} labelHidden={false} />
          </Stack>
        </div>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default TagsSelectionCard;